import React, { useState } from "react";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import Translator from "Languages/Utility/Translator";
import { useDispatch, useSelector } from "react-redux";
import { read, store } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import UntiBarService from "Services/http/endpoints/design/UntiBarService";
import showNotify from "Helpers/Notify";
import { setSelectedUnitCount } from "Stores/actions";
import { DRAWER_RESET } from "Stores/actionTypes";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { useTranslation } from 'react-i18next';
import * as Icons from 'react-bootstrap-icons';

function DeleteUnit({ page, getUnitData, setUnitData }) {
  const { t } = useTranslation();
  const { unitList, selectedProject, selectedUnitId, unitListPagination, selectedUnitCount } = useSelector(
    (state) => ({
      unitList: state.design.unitList,
      selectedProject: state.project.selectedProject,
      selectedUnitId: state.design.selectedUnitId,
      unitListPagination: state.design.unitListPagination,
      selectedUnitCount: state.design.selectedUnitCount,
    })
  );
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      resetDrawer();
      await deleteUnits()
      await updateUnitList();
      showNotify({
        text: t('wasDeletedSuccessfully'),
        customClass: "success",
      });
      onClose();
    } catch (e) {
      onClose();
    }
  };

  const onClose = () => {
    onShowAlert();
    setLoading(false);
  }

  const resetDrawer = () => {
    unitList.map(items => {
      if(items.Id === selectedUnitId) {
        if(items.IsSelect) {
          dispatch({type: DRAWER_RESET});
          store("unitId", undefined);
        }
      }
    })
  }

  const deleteUnits = async () => {
    const params = {
      KeyGroup: read("groupKey"),
      KeyUser: read("userKey"),
      ProjectIdSelected:selectedProject.Id,
    };
    const response = await UntiBarService.deleteUnitArray(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      dispatch(setSelectedUnitCount(0));
      return true;
    }
    else return false;
  }

  const updateUnitList = async () => {
    const data = await getUnitData(1, (page * 20), false);
    setUnitData(data.Value, { Limit: 20, Page: page, Total: data.Pagination.Total });
  }

  return (
    <>
      <MuiIconButton
        title={<Translator id="deleteUnit" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={selectedUnitCount === 0}
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}

export default DeleteUnit;
